// Schoonmakers worden overal alfabetisch getoond (op naam), zodat de volgorde
// niet per taak anders is.
export const compareNames = (a, b) => String(a || '').localeCompare(String(b || ''), undefined, { sensitivity: 'base' });
export const sortedNames = (names) => names.filter(Boolean).sort(compareNames);
export const sortByName = (items, getName = (x) => x.name) => [...items].sort((a, b) => compareNames(getName(a), getName(b)));
